export default __webpack_public_path__ + "static/media/laptop.f35e824e.png";